import analyticsApiFactory from '../../modules/analytics/analyticsApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  sendPageLoadEventActionCreators,
  sendProductListEventActionCreators,
  sendProductClickEventActionCreators,
  sendProductClickAnalyticsEventActionCreators,
  sendAddToCartClickEventActionCreators,
  sendAddToCartClickAnalyticsEventActionCreators,
  sendPreOrderClickEventActionCreators,
  sendWebtrekkEventActionCreators,
  sendChangeVariantClickEventActionCreators,
  sendOpenVariantPopupEventActionCreators,
  sendCloseVariantPopupEventActionCreators,
  sendFeedbackViewEventActionCreators,
  sendFeedbackClickEventActionCreators,
  sendFilterWidgetClickEventActionCreators,
  sendTypoCorrectionViewEventActionCreators,
  sendTypoCorrectionClickEventActionCreators,
  sendRecoProductsClickEventActionCreators,
  sendRecoProductsViewEventActionCreators,
  sendRecoProductsArrowClickEventActionCreators,
  sendDealOfTheDayTitleClickEventActionCreators,
  sendDealOfTheDayProductsClickEventActionCreators,
  sendDealOfTheDayArrowClickEventActionCreators,
  sendDealOfTheDayViewEventActionCreators,
  sendFilterFacetClickEventActionCreators,
  sendMultiFilterFacetClickEventActionCreators,
  sendSortClickEventActionCreators,
  sendSortClickAnalyticsEventActionCreators,
  sendSmartFilterViewEventActionCreators,
  sendHomePageViewEventActionCreators,
  sendRemoveFiltersEventActionCreators,
  sendSponsoredProductViewEventActionCreators,
  sendSponsoredProductClickEventActionCreators,
  sendCampaignTagClickEventActionCreators,
  sendImageViewEventActionCreators,
  sendProductListViewEventActionCreators, sendProductViewEventActionCreators,
} from '../actions/analyticsActions';

function analyticsSagasFactory({storefrontApiClient, hbusApiClient, webtrekkApiClient, googleAnalyticsClient}) {
  const analyticsApi = analyticsApiFactory(storefrontApiClient, hbusApiClient, webtrekkApiClient, googleAnalyticsClient);

  const sendPageLoadEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendPageLoadEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendProductListEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendProductListEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendProductClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendProductClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendProductClickAnalyticsEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendGaEvent,
    sendProductClickAnalyticsEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendAddToCartClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendAddToCartClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendAddToCartClickAnalyticsEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendGaEvent,
    sendAddToCartClickAnalyticsEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendPreOrderClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendPreOrderClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendChangeVariantClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendChangeVariantClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendOpenVariantPopupEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendOpenVariantPopupEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendCloseVariantPopupEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendCloseVariantPopupEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendWebtrekkEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendWebtrekkEvent,
    sendWebtrekkEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendFeedbackViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendFeedbackViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendFeedbackClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendFeedbackClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendFilterWidgetClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendFilterWidgetClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendTypoCorrectionViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendTypoCorrectionViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendTypoCorrectionClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendTypoCorrectionClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendRecoProductsClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendRecoProductsClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendRecoProductsViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendRecoProductsViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendRecoProductsArrowClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendRecoProductsArrowClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendDealOfTheDayTitleClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendDealOfTheDayTitleClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendDealOfTheDayProductClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendDealOfTheDayProductsClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendDealOfTheDayArrowClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendDealOfTheDayArrowClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendDealOfTheDayViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendDealOfTheDayViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendFilterFacetClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendFilterFacetClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendMultiFilterFacetClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendMultiDavinciEvent,
    sendMultiFilterFacetClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendSortClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendSortClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendSortClickAnalyticsEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendGaEvent,
    sendSortClickAnalyticsEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendSmartFilterViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendSmartFilterViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendHomePageViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendHomePageViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendRemoveFiltersEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendRemoveFiltersEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendSponsoredProductViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendSponsoredProductViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendSponsoredProductClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendSponsoredProductClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendProductListViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendProductListViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendCampaignTagClickEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendCampaignTagClickEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendImageViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendImageViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const sendProductViewEventSaga = generateDefaultAsyncSaga(
    analyticsApi.sendDavinciEvent,
    sendProductViewEventActionCreators,
    payload => [
      payload.params,
    ],
  );

  const watchSendPageLoadEvent = generateDefaultAsyncWatcher(
    'SEND_PAGE_LOAD_EVENT',
    sendPageLoadEventSaga,
  );

  const watchSendProductListEvent = generateDefaultAsyncWatcher(
    'SEND_PRODUCT_LIST_EVENT',
    sendProductListEventSaga,
  );

  const watchSendProductClickEvent = generateDefaultAsyncWatcher(
    'SEND_PRODUCT_CLICK_EVENT',
    sendProductClickEventSaga,
  );

  const watchSendProductClickAnalyticsEvent = generateDefaultAsyncWatcher(
    'SEND_PRODUCT_CLICK_ANALYTICS_EVENT',
    sendProductClickAnalyticsEventSaga,
  );

  const watchSendAddToCartClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_ADD_TO_CART_CLICK_EVENT',
    sendAddToCartClickEventSaga,
  );

  const watchSendAddToCartClickAnalyticsEventSaga = generateDefaultAsyncWatcher(
    'SEND_ADD_TO_CART_CLICK_ANALYTICS_EVENT',
    sendAddToCartClickAnalyticsEventSaga,
  );

  const watchSendPreOrderClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_PRE_ORDER_CLICK_EVENT',
    sendPreOrderClickEventSaga,
  );

  const watchSendChangeVariantEventSaga = generateDefaultAsyncWatcher(
    'SEND_CHANGE_VARIANT_CLICK_EVENT',
    sendChangeVariantClickEventSaga,
  );

  const watchOpenVariantPopupEventSaga = generateDefaultAsyncWatcher(
    'SEND_OPEN_VARIANT_POPUP_EVENT',
    sendOpenVariantPopupEventSaga,
  );

  const watchCloseVariantPopupEventSaga = generateDefaultAsyncWatcher(
    'SEND_CLOSE_VARIANT_POPUP_EVENT',
    sendCloseVariantPopupEventSaga,
  );

  const watchsendWebtrekkEventSaga = generateDefaultAsyncWatcher(
    'SEND_WEBTREKK_EVENT',
    sendWebtrekkEventSaga,
  );

  const watchSendFeedbackViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_FEEDBACK_VIEW_EVENT',
    sendFeedbackViewEventSaga,
  );

  const watchSendFeedbackClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_FEEDBACK_CLICK_EVENT',
    sendFeedbackClickEventSaga,
  );

  const watchSendFilterWidgetClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_FILTER_WIDGET_CLICK_EVENT',
    sendFilterWidgetClickEventSaga,
  );

  const watchSendTypoCorrectionViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_TYPO_CORRECTION_VIEW_EVENT',
    sendTypoCorrectionViewEventSaga,
  );

  const watchSendTypoCorrectionClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_TYPO_CORRECTION_CLICK_EVENT',
    sendTypoCorrectionClickEventSaga,
  );

  const watchSendRecoProductsClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_RECO_PRODUCTS_CLICK_EVENT',
    sendRecoProductsClickEventSaga,
  );

  const watchSendRecoProductsViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_RECO_PRODUCTS_VIEW_EVENT',
    sendRecoProductsViewEventSaga,
  );

  const watchSendRecoProductsArrowClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_RECO_PRODUCTS_ARROW_CLICK_EVENT',
    sendRecoProductsArrowClickEventSaga,
  );

  const watchSendDealOfTheDayTitleClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_DEAL_OF_THE_DAY_TITLE_CLICK_EVENT',
    sendDealOfTheDayTitleClickEventSaga,
  );

  const watchSendDealOfTheDayProductClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_DEAL_OF_THE_DAY_PRODUCT_CLICK_EVENT',
    sendDealOfTheDayProductClickEventSaga,
  );

  const watchSendDealOfTheDayArrowClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_DEAL_OF_THE_DAY_ARROW_CLICK_EVENT',
    sendDealOfTheDayArrowClickEventSaga,
  );

  const watchSendDealOfTheDayViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_DEAL_OF_THE_DAY_VIEW_EVENT',
    sendDealOfTheDayViewEventSaga,
  );

  const watchSendFilterFacetClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_FILTER_FACET_CLICK_EVENT',
    sendFilterFacetClickEventSaga,
  );

  const watchSendMultiFilterFacetClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_MULTI_FILTER_FACET_CLICK_EVENT',
    sendMultiFilterFacetClickEventSaga,
  );

  const watchSendSortClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_SORT_CLICK_EVENT',
    sendSortClickEventSaga,
  );

  const watchSendSortClickAnalyticsEventSaga = generateDefaultAsyncWatcher(
    'SEND_SORT_CLICK_ANALYTICS_EVENT',
    sendSortClickAnalyticsEventSaga,
  );

  const watchSendSmartFilterCViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_SMART_FILTER_VIEW',
    sendSmartFilterViewEventSaga,
  );

  const watchSendHomePageViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_HOME_PAGE_VIEW',
    sendHomePageViewEventSaga,
  );

  const watchRemoveFiltersEventSaga = generateDefaultAsyncWatcher(
    'SEND_REMOVE_FILTERS',
    sendRemoveFiltersEventSaga,
  );

  const watchSponsoredProductViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_SPONSORED_PRODUCT_VIEW',
    sendSponsoredProductViewEventSaga,
  );

  const watchSponsoredProductClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_SPONSORED_PRODUCT_CLICK',
    sendSponsoredProductClickEventSaga,
  );

  const watchProductListViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_PRODUCT_LIST_VIEW',
    sendProductListViewEventSaga,
  );

  const watchCampaignTagClickEventSaga = generateDefaultAsyncWatcher(
    'SEND_CAMPAIGN_TAG_CLICK',
    sendCampaignTagClickEventSaga,
  );

  const watchImageViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_IMAGE_VIEW',
    sendImageViewEventSaga,
  );

  const watchProductViewEventSaga = generateDefaultAsyncWatcher(
    'SEND_PRODUCT_VIEW',
    sendProductViewEventSaga,
  )

  const analyticsSagas = [
    watchSendPageLoadEvent(),
    watchSendProductListEvent(),
    watchSendProductClickEvent(),
    watchSendProductClickAnalyticsEvent(),
    watchSendAddToCartClickEventSaga(),
    watchSendAddToCartClickAnalyticsEventSaga(),
    watchSendPreOrderClickEventSaga(),
    watchsendWebtrekkEventSaga(),
    watchSendChangeVariantEventSaga(),
    watchOpenVariantPopupEventSaga(),
    watchCloseVariantPopupEventSaga(),
    watchSendFeedbackViewEventSaga(),
    watchSendFeedbackClickEventSaga(),
    watchSendFilterWidgetClickEventSaga(),
    watchSendTypoCorrectionViewEventSaga(),
    watchSendTypoCorrectionClickEventSaga(),
    watchSendRecoProductsClickEventSaga(),
    watchSendRecoProductsViewEventSaga(),
    watchSendRecoProductsArrowClickEventSaga(),
    watchSendDealOfTheDayTitleClickEventSaga(),
    watchSendDealOfTheDayProductClickEventSaga(),
    watchSendDealOfTheDayArrowClickEventSaga(),
    watchSendDealOfTheDayViewEventSaga(),
    watchSendFilterFacetClickEventSaga(),
    watchSendMultiFilterFacetClickEventSaga(),
    watchSendSortClickEventSaga(),
    watchSendSortClickAnalyticsEventSaga(),
    watchSendSmartFilterCViewEventSaga(),
    watchSendHomePageViewEventSaga(),
    watchRemoveFiltersEventSaga(),
    watchSponsoredProductViewEventSaga(),
    watchSponsoredProductClickEventSaga(),
    watchProductListViewEventSaga(),
    watchCampaignTagClickEventSaga(),
    watchImageViewEventSaga(),
    watchProductViewEventSaga()
  ];

  return analyticsSagas;
}

export default analyticsSagasFactory;
